import _ from "lodash";

export function flatten (characteristics)
{
	let flattened = [];

	_.forEach(characteristics, characteristic =>
	{
		flattened = _.concat(flattened, flat(characteristic));
	});

	return flattened;
}

function flat (characteristic)
{
	let flattened = [ characteristic ];

	_.forEach(characteristic.children || [], child =>
	{
		flattened = _.concat(flattened, flat(child));
	});

	return flattened;
}